import axios, { AxiosResponse } from "axios";
import { ContainerType } from "@Base/Engagement/ContainerType";
import { EngagementService } from "@Api/EngagementService";
import { Product } from "@Base/Engagement/Product";
import { ProductCarousel } from "@Base/Engagement/ProductCarousel";
import { RecommendationBase } from "@Base/Engagement/RecommendationBase";
import { Tenant } from "@Utilities/Tenant";

import HcProductCard from "@Tenants/Hc/Templates/ProductCard.hbs";
import FunProductCard from "@Tenants/Fun/Templates/ProductCard.hbs";
export class LocalRecommendation extends RecommendationBase
{
	private readonly engagementService: EngagementService;
	private readonly providerName: string = "local";

	constructor()
	{
		super();
		this.engagementService = new EngagementService();
	}

	public RenderRecommendations = (containerType: string, divName: string, title: string, elementName: string): void =>
	{
		const recsJson = document.getElementById(elementName) as HTMLInputElement;
		const recommendations = this.HydrateLocalPlacement(recsJson.value) as Product[];

		if (recommendations.length > 0)
		{
			let html = "";
			let carousel = void 0;

			const div = document.getElementById(divName) as HTMLElement;

			if (div !== null)
			{
				carousel = new ProductCarousel(divName, title, recommendations);
				carousel.AddToCart = true;
				carousel.EnableSlider = true;
				if (containerType === ContainerType.FunLocal)
				{
					html = FunProductCard(carousel);
				}
				else if (containerType === ContainerType.HCLocal)
				{
					html = HcProductCard(carousel);
				}
				div.outerHTML = html;
				this.ConfigureFourUpCarousel("#" + divName);
				this.ConfigureThemeAddItems("#" + divName);

				//output product ids to block from repeating in other containers.
				for (let i = 0; i < recommendations.length; i++)
				{
					const container = document.getElementById(divName) as HTMLElement;
					const exclusionContainer = document.createElement("div");
					exclusionContainer.classList.add("exclude-product");
					exclusionContainer.style.display = "none";
					exclusionContainer.innerHTML = recommendations[i].ProductID;
					container.appendChild(exclusionContainer);

					//only exclude the first 8 items
					if (i == 7)
					{
						break;
					}
				}

				//this.TrackRecommendationShown(title, recommendations);
			}
		}
	};

	public RenderRecentlyViewed = (containerType: string, divName: string, title: string): void =>
	{
		// On PDP and ATC, productId needs to be exluded from the recommendation list.
		let productId: number = 0;
		const productIdEl = document.querySelector("input[name='ProductID']") as HTMLInputElement;

		if (productIdEl !== null)
		{
			const productIdValue = productIdEl.value;
			if (productIdValue !== "")
			{
				productId = parseInt(productIdValue, 10);
			}
		}

		this.engagementService.GetRecentlyViewed(productId)
			.then((response: AxiosResponse) =>
			{
				if (response.data && response.data.length > 0)
				{
					const recommendations = this.HydrateLocalPlacement(response.data) as Product[];

					switch (Tenant.Type)
					{
						case "HC":
						case "HW":
							if (containerType === ContainerType.HCProductCard)
							{
								this.RenderHCProductCard(divName, title, recommendations);
							}
							break;
						case "Fun":
							if (containerType === ContainerType.FunProductCard)
							{
								this.RenderFunProductCard(divName, title, recommendations);
							}
							else if (containerType === ContainerType.RecentlyViewedSide)
							{
								this.RenderRecentlyViewedSide(divName, recommendations);
							}
							break;
						default:
							break;
					}

					//this.TrackRecommendationShown(title, recommendations);
				};
			})
			.catch((error) =>
			{
				console.log(error);
			});;
	};
}